import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-50 py-12 mt-auto">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="text-left">
            <Link to="/" className="flex items-start">
              <img 
                src="/lovable-uploads/e8744470-4d22-410f-8465-50d77f19a568.png" 
                alt="AppLaunchAI Logo" 
                className="h-25"
              />
            </Link>
            <p className="mt-4 text-sm text-gray-600 text-left">
              The ultimate guide to building and launching successful mobile apps with AI
            </p>
          </div>
          
          <div className="text-left">
            <h3 className="font-medium text-gray-900 text-left">Products</h3>
            <ul className="mt-4 space-y-2 text-left">
              <li>
                <Link to="/pricing" className="text-sm text-gray-600 hover:text-blue-600">
                  AI App Launch Guide
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm text-gray-600 hover:text-blue-600">
                  AI Development Swipe File &amp; Prompts
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm text-gray-600 hover:text-blue-600">
                  AI App Fast-Track
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm text-gray-600 hover:text-blue-600">
                  AI App Accelerator
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm text-gray-600 hover:text-blue-600">
                  AI App Business Mastery
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm text-gray-600 hover:text-blue-600">
                  Unlimited AI App Development
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm text-gray-600 hover:text-blue-600">
                  Elite VIP Service
                </Link>
              </li>
            </ul>
          </div>
          
          <div className="text-left">
            <h3 className="font-medium text-gray-900 text-left">Resources</h3>
            <ul className="mt-4 space-y-2 text-left">
              <li>
                <Link to="/faq" className="text-sm text-gray-600 hover:text-blue-600">
                  FAQ
                </Link>
              </li>
              <li>
                <a href="mailto:support@applaunchai.com" className="text-sm text-gray-600 hover:text-blue-600">
                  Support
                </a>
              </li>
            </ul>
          </div>
          
          <div className="text-left">
            <h3 className="font-medium text-gray-900 text-left">Company</h3>
            <ul className="mt-4 space-y-2 text-left">
              <li>
                <Link to="/about" className="text-sm text-gray-600 hover:text-blue-600">
                  About
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-sm text-gray-600 hover:text-blue-600">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-sm text-gray-600 hover:text-blue-600">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/refund-policy" className="text-sm text-gray-600 hover:text-blue-600">
                  Refund Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-12 border-t border-gray-200 pt-6 text-left">
          <p className="text-left text-sm text-gray-600">
            © {currentYear} AppLaunchAI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
